var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNothingHere(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 191,
    viewBox: "0 0 206 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_841_40565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.3405 153.685C92.6686 154.939 69.5482 160.533 55.3525 148.264C48.9884 142.764 51.4292 139.739 43.2682 130.808C32.8161 119.353 26.5718 121.876 19.1146 113.352C9.47112 102.352 7.38969 83.8775 12.2114 70.621C15.6106 61.3133 19.5788 62.3318 32.3369 46.5526C36.6046 41.2876 39.5695 36.9472 41.8157 33.2805C49.0034 21.5754 48.659 20.4315 51.8635 16.4201C64.8313 0.0924053 92.1145 2.89726 96.0078 3.28899C99.9461 3.6964 106.116 4.38586 113.303 7.78615C126.106 13.8346 125.912 20.8546 136.244 28.1566C152.266 39.5013 171.109 25.5742 189.737 37.8591C193.6 40.4133 197.913 44.7846 201.686 53.1051C208.11 67.3017 201.385 87.9164 191.457 99.5119C179.238 113.787 164.141 108.275 143.536 125.919C134.657 133.519 132.725 138.376 122.078 144.66C119.323 146.289 110.129 150.254 97.3405 153.685Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.515 65.9618L94.8218 70.5375C87.6769 71.2691 82.4792 77.6399 83.2126 84.7672L90.4435 155.047C91.1768 162.174 97.5634 167.359 104.708 166.627L149.401 162.052C156.546 161.32 161.744 154.949 161.011 147.822L153.78 77.5425C153.046 70.4151 146.66 65.2303 139.515 65.9618Z",
    fill: "white",
    stroke: "#B8B8B8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.531 53.0029L173.259 64.7015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.531 53.0029L173.259 64.7015",
    stroke: "#B8B8B8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.537 53.2971C169.443 57.006 165.364 60.7149 161.27 64.4238Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.537 53.2971C169.443 57.006 165.364 60.7149 161.27 64.4238",
    stroke: "#B8B8B8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7596 41.664C89.1478 41.664 91.0837 39.7328 91.0837 37.3505C91.0837 34.9683 89.1478 33.0371 86.7596 33.0371C84.3715 33.0371 82.4355 34.9683 82.4355 37.3505C82.4355 39.7328 84.3715 41.664 86.7596 41.664Z",
    fill: "white",
    stroke: "#B8B8B8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0452 101.839C44.3289 101.839 46.9908 99.1841 46.9908 95.9085C46.9908 92.6329 44.3289 89.9775 41.0452 89.9775C37.7616 89.9775 35.0996 92.6329 35.0996 95.9085C35.0996 99.1841 37.7616 101.839 41.0452 101.839Z",
    fill: "white",
    stroke: "#B8B8B8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6787 56.81C66.3356 55.4703 66.0735 52.2515 64.3537 51.794C62.6339 51.3366 60.7339 54.0161 58.965 54.4736C57.196 54.9311 54.2969 53.4933 52.9538 54.833C51.6108 56.1728 53.0521 59.1301 52.5935 60.8294C52.1349 62.5286 49.4323 64.4402 49.9073 66.2048C50.3823 67.9694 53.5926 68.1818 54.9357 69.5216C56.2788 70.8614 56.5409 74.0801 58.2607 74.5376C59.9805 74.9951 61.8805 72.3155 63.6494 71.858C65.4183 71.4005 68.3174 72.8383 69.6605 71.4986C71.0036 70.1588 69.5623 67.2015 70.0209 65.5022C70.4795 63.803 73.182 61.8914 72.707 60.1268C72.2321 58.3622 69.0217 58.1498 67.6787 56.81Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6787 56.81C66.3356 55.4703 66.0735 52.2515 64.3537 51.794C62.6339 51.3366 60.7339 54.0161 58.965 54.4736C57.196 54.9311 54.2969 53.4933 52.9538 54.833C51.6108 56.1728 53.0521 59.1301 52.5935 60.8294C52.1349 62.5286 49.4323 64.4402 49.9073 66.2048C50.3823 67.9694 53.5926 68.1818 54.9357 69.5216C56.2788 70.8614 56.5409 74.0801 58.2607 74.5376C59.9805 74.9951 61.8805 72.3155 63.6494 71.858C65.4183 71.4005 68.3174 72.8383 69.6605 71.4986C71.0036 70.1588 69.5623 67.2015 70.0209 65.5022C70.4795 63.803 73.182 61.8914 72.707 60.1268C72.2321 58.3622 69.0217 58.1498 67.6787 56.81Z",
    stroke: "#B8B8B8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.992 189.605C145.3 188.141 156.63 184.341 156.298 181.118C155.967 177.896 144.099 176.471 129.791 177.936C115.484 179.4 104.154 183.2 104.485 186.423C104.817 189.645 116.684 191.07 130.992 189.605Z",
    fill: "#B2B2B2",
    stroke: "#B8B8B8",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.672 85.566C114.364 85.566 115.735 84.1981 115.735 82.5107C115.735 80.8232 114.364 79.4553 112.672 79.4553C110.981 79.4553 109.609 80.8232 109.609 82.5107C109.609 84.1981 110.981 85.566 112.672 85.566Z",
    fill: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.275 91.6113C115.718 91.0558 117.601 88.7684 120.73 88.6704C122.908 88.5887 124.579 89.618 125.267 90.1082",
    stroke: "#B8B8B8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.793 84.0138C126.485 84.0138 127.856 82.6458 127.856 80.9584C127.856 79.271 126.485 77.9031 124.793 77.9031C123.102 77.9031 121.73 79.271 121.73 80.9584C121.73 82.6458 123.102 84.0138 124.793 84.0138Z",
    fill: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7592 142.784C95.6785 142.784 102.909 135.572 102.909 126.674C102.909 117.777 95.6785 110.564 86.7592 110.564C77.8399 110.564 70.6094 117.777 70.6094 126.674C70.6094 135.572 77.8399 142.784 86.7592 142.784Z",
    fill: "white",
    stroke: "#B8B8B8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_841_40565"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 206,
    height: 191,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNothingHere);
export default __webpack_public_path__ + "static/media/nothing-here.2c4bacc20d861a160c7f25820013e762.svg";
export { ForwardRef as ReactComponent };